import { create } from "zustand"

import type { Product, ProductListQuery, ProductSortField, SortingOrder } from "@/graphql/codegen/graphql"
import { ProductListDocument } from "@/graphql/codegen/graphql"
import { type SearchFilters, createSearchStore } from "@/stores/createSearchStore"

export type ProductListSearchFilters = SearchFilters & {
  field?: ProductSortField
  order?: SortingOrder
}

const deduplicateProduct = (newData: Product[], existingData: Product[]): Product[] => {
  const uniqueIds = new Set(existingData.map((product) => product.productId))
  return [...existingData, ...newData.filter((product) => !uniqueIds.has(product.productId))]
}

export const useProductListSearchStore = create(
  createSearchStore<Product, ProductListSearchFilters, ProductListQuery>({
    documentNode: ProductListDocument,
    deduplicateData: deduplicateProduct,
    getQueryInput: (filters: ProductListSearchFilters, offset: number, limit: number) => {
      const { field, order, ...otherFilters } = filters
      return {
        filter: otherFilters,
        offset,
        limit,
        sort: { field, order },
      }
    },
    getQueryVariables: (queryInput) => ({ input: queryInput }),
    extractDataFromResponse: (data) => ({
      __typename: data.product.list.__typename,
      data: data.product.list.__typename === "ProductListSuccess" ? (data.product.list.products as Product[]) : [],
      error: data.product.list.__typename === "ProductListFailure" ? data.product.list.error : undefined,
    }),
  })
)
